import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import { CustomTemplateUpdatePayload } from 'models/automation/CustomTemplates';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, CustomTemplateUpdatePayload>,
  'mutationFn' | 'mutationKey'
>;

const updateCustomTemplate = (payload: CustomTemplateUpdatePayload) => {
  const { customTemplateUid, ...rest } = payload;

  return API.patch<unknown, BaseErrorResponse>(
    `/api/internal/automation/custom-templates/${customTemplateUid}`,
    rest,
  );
};

const useUpdateCustomTemplateMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: updateCustomTemplate,
    ...options,
  });
};

export default useUpdateCustomTemplateMutation;
